var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 13.1667H13.558C13.2693 12.206 12.3867 11.5 11.3333 11.5C10.28 11.5 9.398 12.206 9.10869 13.1667H0.666656C0.298656 13.1667 0 13.4653 0 13.8333C0 14.2013 0.298656 14.5 0.666656 14.5H9.10866C9.39731 15.4607 10.28 16.1667 11.3333 16.1667C12.3866 16.1667 13.2687 15.4607 13.558 14.5H15.3333C15.702 14.5 16 14.2013 16 13.8333C16 13.4653 15.702 13.1667 15.3333 13.1667ZM11.3333 14.8333C10.782 14.8333 10.3333 14.3847 10.3333 13.8333C10.3333 13.282 10.782 12.8333 11.3333 12.8333C11.8847 12.8333 12.3333 13.282 12.3333 13.8333C12.3333 14.3847 11.8847 14.8333 11.3333 14.8333Z",
    fill: "#505258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 2.50003H13.558C13.2687 1.53937 12.3867 0.833374 11.3333 0.833374C10.28 0.833374 9.398 1.53937 9.10866 2.50003H0.666656C0.298656 2.50003 0 2.79869 0 3.16669C0 3.53469 0.298656 3.83334 0.666656 3.83334H9.10866C9.398 4.79403 10.28 5.50003 11.3333 5.50003C12.3867 5.50003 13.2687 4.79403 13.558 3.83337H15.3333C15.702 3.83337 16 3.53472 16 3.16672C16 2.79872 15.702 2.50003 15.3333 2.50003ZM11.3333 4.16669C10.782 4.16669 10.3333 3.71803 10.3333 3.16669C10.3333 2.61534 10.782 2.16669 11.3333 2.16669C11.8847 2.16669 12.3333 2.61534 12.3333 3.16669C12.3333 3.71803 11.8847 4.16669 11.3333 4.16669Z",
    fill: "#505258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 7.83334H6.89134C6.602 6.87269 5.72 6.16669 4.66669 6.16669C3.61337 6.16669 2.73134 6.87269 2.44203 7.83334H0.666656C0.298656 7.83334 0 8.132 0 8.5C0 8.868 0.298656 9.16666 0.666656 9.16666H2.442C2.73134 10.1273 3.61334 10.8333 4.66666 10.8333C5.71997 10.8333 6.602 10.1273 6.89131 9.16666H15.3333C15.702 9.16666 16 8.868 16 8.5C16 8.132 15.702 7.83334 15.3333 7.83334ZM4.66666 9.5C4.11531 9.5 3.66666 9.05134 3.66666 8.5C3.66666 7.94866 4.11531 7.5 4.66666 7.5C5.218 7.5 5.66666 7.94866 5.66666 8.5C5.66666 9.05134 5.218 9.5 4.66666 9.5Z",
    fill: "#505258"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.51c708e9040c259a220bac0e9f15f500.svg";
export { ForwardRef as ReactComponent };